import { EnvironmentTypes, SiteConfig, footerApp, headerApp, shellApp } from '@openedx/frontend-base';
import customApp from './src/customApp';
import { addApp, addExternalRoute } from './src/utils';


import { authnApp } from '@openedx/frontend-app-authn';



import { learnerDashboardApp } from '@openedx/frontend-app-learner-dashboard';



import { instructorDashboardApp } from '@openedx/frontend-app-instructor-dashboard';



import { notificationsApp } from '@openedx/frontend-app-notifications';



import {
  createLegacyPluginApp,
  defaultRouteMap,
  defaultSlotMap,
  defaultWidgetMap,
} from '@openedx/frontend-base-compat';
import allEnvConfig from './src/env.config.all.jsx';

const routeMap = { ...defaultRouteMap, ...{} };
const slotMap = { ...defaultSlotMap, ...{} };
const widgetMap = { ...defaultWidgetMap, ...{} };





import '@openedx/frontend-base/shell/style';
import '@edx/brand/core.min.css';
import '@edx/brand/light.min.css';

const siteConfig: SiteConfig = {
  siteId: 'tutor-site',
  siteName: "\u0423\u0440\u0424\u0423",
  baseUrl: 'https://apps.asdebug.ru',
  cmsBaseUrl: 'https://studio.asdebug.ru',
  lmsBaseUrl: 'https://asdebug.ru',
  loginUrl: 'https://asdebug.ru/login',
  logoutUrl: 'https://asdebug.ru/logout',

  environment: EnvironmentTypes.PRODUCTION,
  apps: [
    shellApp,
    headerApp,
    footerApp,
    customApp,
  ],
  externalRoutes: [],

  runtimeConfigJsonUrl: '/api/frontend_site_config/v1/',
  accessTokenCookieName: 'edx-jwt-cookie-header-payload',
};


addApp(siteConfig, authnApp);



addApp(siteConfig, learnerDashboardApp);



addApp(siteConfig, instructorDashboardApp);



addApp(siteConfig, notificationsApp);

addApp(siteConfig, createLegacyPluginApp({
  appId: 'io.edly.frontend.app.compat.all',
  envConfig: allEnvConfig,
  routeMap,
  slotMap,
  widgetMap,
}));




export default siteConfig;